import type { TensionPoint } from '../../music/tension';

/** A piece's portrait: its whole tension curve in a small space. */
export function Sparkline({ points, length, width = 180, height = 38, label }: { points: TensionPoint[]; length: number; width?: number; height?: number; label: string }) {
  if (!points.length) return null;
  const x = (t: number) => 2 + (t / length) * (width - 4);
  const y = (v: number) => 3 + (1 - v) * (height - 6);
  const d = points.map((p, i) => `${i ? 'L' : 'M'}${x(p.t).toFixed(1)},${y(p.v).toFixed(1)}`).join(' ');
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} role="img" aria-label={label}>
      <path d={`${d} L${x(points[points.length - 1].t)},${height} L${x(points[0].t)},${height} Z`} fill="var(--tension-wash)" />
      <path d={d} fill="none" stroke="currentColor" strokeWidth={1.4} strokeLinejoin="round" />
    </svg>
  );
}
